import { forwardRef, createElement } from 'react';
import { b as __rest, au as Search$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Search = /*#__PURE__*/forwardRef(function (_a, ref) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(Search$1, __assign({
    iconBrand: "uq-ec-"
  }, props, {
    ref: ref
  }));
});
Search.displayName = 'Search';

export { Search };
